import { AfterViewInit, Directive, ElementRef, OnDestroy, inject } from "@angular/core";
import { DatePicker } from "@openng/optimus-ui/datepicker";
import { Subscription } from "rxjs";

@Directive({
    selector: "p-date-picker, p-datepicker, p-datePicker",
    standalone: false
})
export class DatePickerKeyboardDirective implements AfterViewInit, OnDestroy {

    private datePicker = inject(DatePicker, { self: true });
    private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
    private buttonObserver: MutationObserver;
    private onShowSubscription: Subscription;
    private focusCalendarOnShow = false;

    ngAfterViewInit(): void {
        this.removeButtonFromTabOrder();
        this.buttonObserver = new MutationObserver(() => this.removeButtonFromTabOrder());
        this.buttonObserver.observe(this.elementRef.nativeElement, { childList: true });
        this.elementRef.nativeElement.addEventListener("keydown", this.onKeyDown, { capture: true });
        this.onShowSubscription = this.datePicker.onShow.subscribe(overlay => this.focusCalendar(overlay));
    }

    ngOnDestroy(): void {
        this.buttonObserver?.disconnect();
        this.elementRef.nativeElement.removeEventListener("keydown", this.onKeyDown, { capture: true });
        this.onShowSubscription?.unsubscribe();
    }

    private onKeyDown = (event: KeyboardEvent): void => {
        if (event.key != "Enter" || event.target != this.datePicker.inputfieldViewChild?.nativeElement || this.datePicker.overlayVisible) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        this.focusCalendarOnShow = true;
        this.datePicker.showOverlay();
    };

    private focusCalendar(overlay: HTMLElement): void {
        if (!this.focusCalendarOnShow) {
            return;
        }

        this.focusCalendarOnShow = false;
        let focusedCell = overlay.querySelector<HTMLElement>(".p-datepicker-day[tabindex='0'], .p-datepicker-month[tabindex='0'], .p-datepicker-year[tabindex='0']");
        let selectedCell = overlay.querySelector<HTMLElement>(".p-datepicker-day-selected:not(.p-disabled), .p-datepicker-month-selected:not(.p-disabled), .p-datepicker-year-selected:not(.p-disabled)");
        let target = selectedCell ?? focusedCell ?? overlay.querySelector<HTMLElement>("button:not([disabled])");
        if (target != null) {
            if (focusedCell != null && focusedCell != target) {
                focusedCell.tabIndex = -1;
            }
            target.tabIndex = 0;
            target.focus();
        }
    }

    private removeButtonFromTabOrder(): void {
        let button = this.elementRef.nativeElement.querySelector<HTMLButtonElement>(".p-datepicker-dropdown");
        if (button != null) {
            button.tabIndex = -1;
        }
    }

}
